// Module
var code = " <gh-grid-cell-editor-container [control]=\"control\"> <div class=\"input-wrapper\"> <input #input=\"\" class=\"cell-input text-right\" [required]=\"required\" [formControl]=\"control\" [ghQuantityType]=\"type\" [ghQuantityTypeFormatOnFocus]=\"isFormatOnFocus\" (blur)=\"onBlur()\" type=\"text\"> </div> </gh-grid-cell-editor-container> ";
// Exports
module.exports = code;